import React from 'react'
import BaseIcon from 'react-icon-base'

import { IStarProps } from './interface'

const Star = (props: IStarProps) => (
  <BaseIcon width="40" height="40" viewBox="0 0 40 40" {...props}>
    <title>{props.title ? props.title : 'Star'}</title>
    <defs>
      <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
        <stop stopColor="#ececec" offset="0%" />
        <stop stopColor="#6f7c89" offset="10%" />
      </linearGradient>
      <filter x="-10.4%" y="-10.4%" width="120.8%" height="120.8%" filterUnits="objectBoundingBox" id="filter-2">
        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.124180507 0"
          type="matrix"
          in="shadowOffsetOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g id="Sprint-Gamification" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.25">
      <g id="Sprint-Gamification---01---2---1440px" transform="translate(-452.000000, -658.000000)">
        <g id="Details" transform="translate(248.000000, 80.000000)">
          <g id="Stats" transform="translate(24.000000, 462.000000)">
            <g id="Icon---Achievement-02" transform="translate(180.000000, 116.000000)">
              <circle id="Oval-3" fill="url(#linearGradient-1)" cx="20" cy="20" r="20" />
              <g id="star" filter="url(#filter-2)" transform="translate(8.000000, 9.000000)" fillRule="nonzero">
                <path
                  d="M21.2207812,6.93454687 L14.9516719,6.35310937 L12.4613906,0.57046875 C12.2870156,0.1655625 11.7129375,0.1655625 11.5386094,0.57046875 L9.04832812,6.3530625 L2.77921875,6.93454687 C2.34023437,6.97523437 2.16285937,7.52123437 2.49403125,7.8121875 L7.22409375,11.9674688 L5.83982812,18.1094531 C5.74289062,18.5395312 6.207375,18.8769375 6.58640625,18.6518906 L12,15.4373906 L17.4135937,18.6518906 C17.7926719,18.8769844 18.2570625,18.5395312 18.1601719,18.1094531 L16.7758594,11.9674688 L21.5059687,7.8121875 C21.8371406,7.52123437 21.6597187,6.97523437 21.2207812,6.93454687 Z"
                  id="Path"
                  fill="#cdd2d7"
                />
                <g id="Group" fill="#cdd2d7">
                  <path
                    d="M5.59115625,0.371390625 C5.91075,0.815296875 6.8128125,2.72170313 7.32853125,3.83273438 C7.409625,4.00739063 7.19048438,4.16517188 7.0505625,4.03284375 C6.16054687,3.19134375 4.63875,1.73109375 4.31915625,1.28714063 C4.06626562,0.93590625 4.146,0.44615625 4.49728125,0.193265625 C4.84851563,-0.059625 5.33826563,0.02015625 5.59115625,0.371390625 Z"
                    id="Path"
                  />
                  <path
                    d="M18.4088437,0.371390625 C18.08925,0.815296875 17.1871875,2.72170313 16.6714687,3.83273438 C16.590375,4.00739063 16.8095156,4.16517188 16.9494375,4.03284375 C17.8394531,3.19134375 19.3612031,1.73104688 19.6808437,1.28714063 C19.9337344,0.93590625 19.854,0.44615625 19.5027187,0.193265625 C19.1514844,-0.059625 18.6617344,0.02015625 18.4088437,0.371390625 Z"
                    id="Path"
                  />
                  <path
                    d="M23.4591094,13.3888594 C22.9390781,13.2192656 20.8486875,12.9390938 19.6335469,12.7853438 C19.4425313,12.7611563 19.3588125,13.0178906 19.5273281,13.1109844 C20.5995,13.70325 22.4530781,14.709375 22.9731094,14.8789688 C23.3845781,15.0131719 23.8269375,14.7884063 23.9611406,14.3768906 C24.0953437,13.965375 23.8705781,13.5230625 23.4591094,13.3888594 Z"
                    id="Path"
                  />
                  <path
                    d="M0.540890625,13.3888594 C1.06092188,13.2192656 3.1513125,12.9390938 4.36645312,12.7853438 C4.55746875,12.7611563 4.6411875,13.0178906 4.47267187,13.1109844 C3.4005,13.70325 1.54692188,14.709375 1.02689062,14.8789688 C0.615421875,15.0131719 0.1730625,14.7884063 0.038859375,14.3768906 C-0.09534375,13.965375 0.129421875,13.5230625 0.540890625,13.3888594 Z"
                    id="Path"
                  />
                  <path
                    d="M11.2403437,22.2332813 C11.2403437,21.6862969 11.6221406,19.6120781 11.8527656,18.409125 C11.889,18.2200313 12.1590469,18.2200313 12.1952812,18.409125 C12.4259062,19.6120781 12.8077031,21.6862969 12.8077031,22.2332813 C12.8077031,22.6660781 12.4568437,23.0169375 12.0240469,23.0169375 C11.5912031,23.0169375 11.2403437,22.6660781 11.2403437,22.2332813 Z"
                    id="Path"
                  />
                </g>
                <path
                  d="M13.3669219,2.67328125 L12.4613437,0.57046875 C12.2869687,0.1655625 11.7128906,0.1655625 11.5385625,0.57046875 L9.04828125,6.3530625 L2.77921875,6.93454688 C2.34023437,6.97523438 2.16285937,7.52123438 2.49403125,7.8121875 L7.22409375,11.9674688 L5.83982812,18.1094531 C5.74289062,18.5395313 6.207375,18.8769375 6.58640625,18.6518906 L7.30692187,18.2240625 C8.488125,10.5778125 11.8088437,4.96490625 13.3669219,2.67328125 Z"
                  id="Path"
                  fill="#cdd2d7"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseIcon>
)

export default Star as React.FunctionComponent<IStarProps>
